export const GET_DASHBOARD_REQUEST = 'dashboard/GET_DASHBOARD_REQUEST';
export const DASHBOARD_PAGE_REQUEST = 'DASHBOARD_PAGE_REQUEST';
export const DASHBOARD_LAZY_LOAD_PAGE_REQUEST =
  'DASHBOARD_LAZY_LOAD_PAGE_REQUEST';
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const DASHBOARD_TABLE_SUMMARY_REQUEST =
  'DASHBOARD_TABLE_SUMMARY_REQUEST';
export const DASHBOARD_ITEM_SUMMARY_REQUEST = 'DASHBOARD_ITEM_SUMMARY_REQUEST';
export const DASHBOARD_TOP_ITEMS_BY_CATEGORY_REQUEST =
  'DASHBOARD_TOP_ITEMS_BY_CATEGORY_REQUEST';
export const DASHBOARD_TOP_CATEGORIES_BY = 'DASHBOARD_TOP_CATEGORIES_BY';
export const DASHBOARD_CHANGE_OUTLET = 'DASHBOARD_CHANGE_OUTLET';
export const DASHBOARD_CHANGE_DATE = 'DASHBOARD_CHANGE_DATE';
export const DASHBOARD_SET_OUTLETS = 'DASHBOARD_SET_OUTLETS';
